<div class="cn-container">
    <div class="cn-left">
        <div>
            <button
                type="button"
                class="btn bg-transparent p-0"
                (click)="$event.stopPropagation()"
                mwlCalendarToday
                [viewDate]="viewDate"
                (viewDateChange)="viewDateChange.next($event)"
            >
                {{ _i18n._9569_TODAY | translate }}
            </button>
        </div>
        <div class="d-flex align-items-center px-2">
            <button
                type="button"
                class="btn bg-transparent p-0"
                (click)="$event.stopPropagation()"
                mwlCalendarPreviousView
                [view]="view"
                [viewDate]="viewDate"
                (viewDateChange)="viewDateChange.next($event)"
            >
                <!--<i class="fa fa-2x fa-angle-left" aria-hidden="true"></i>-->
                <cmps-icon svgIcon="chevron-left"></cmps-icon>
            </button>
            <button
                type="button"
                class="btn bg-transparent p-0"
                (click)="$event.stopPropagation()"
                mwlCalendarNextView
                [view]="view"
                [viewDate]="viewDate"
                (viewDateChange)="viewDateChange.next($event)"
            >
                <!--<i class="fa fa-2x fa-angle-right" aria-hidden="true"></i>-->
                <cmps-icon svgIcon="chevron-right"></cmps-icon>
            </button>
        </div>
        <div class="d-flex align-items-center px-2">
            <span>{{
                viewDate | calendarDate: view + 'ViewTitle' : 'en'
            }}</span>
            <!--<span>{{viewDate | date: 'MMMM yyyy'}}</span>-->
            <cmps-icon
                class="mr-3"
                svgIcon="chevron-down"
            ></cmps-icon>
        </div>
    </div>
    <div class="cn-center">
        <span
            >{{ _i18n._9687_PERFORMER_ | translate }}
            {{ _i18n._9688_SHOW_ALL | translate }}</span
        >
        <cmps-icon
            class="mr-3"
            svgIcon="chevron-down"
        ></cmps-icon>
    </div>
    <div class="cn-right">
        <div>
            <span
                >{{ _i18n._9689_SHOWING_BY_ | translate }}
                {{ _i18n._829_WEEK | translate }}</span
            >
            <cmps-icon
                class="mr-3"
                svgIcon="chevron-down"
            ></cmps-icon>
        </div>
    </div>
</div>
